import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import OrderLayout from '../../layout/order-layout'
import FactureProFormatComponent from '../../components/pro-format'
import axios from 'axios'
import { APP_API_URL } from '../../utils'
import { useNavigate } from 'react-router-dom';

export default function ProFormatInvoice() {
  const navigate = useNavigate();
  const location = useLocation();
  const reference = location.state?.reference || null;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!reference) {
      setError('Référence manquante');
      return;
    }

    setLoading(true);
    const token = localStorage.getItem('token'); // ou la source où tu stockes le token

    axios.get(`${APP_API_URL}/pros-format/${reference}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(response => {
        setData(response.data);
        setError(null);
      })
      .catch(err => {
        setError('Erreur lors du chargement de la facture.');
        setData(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [reference]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) return <div>Chargement...</div>;
  if (error) return <div className="text-red-600">{error}</div>;

  return (
    <OrderLayout document>
      <div className='mx-auto w-full max-w-6xl bg-white p-4 sm:p-6 lg:p-8'>
        <div className='printable w-full'>
          {data ? (
            <FactureProFormatComponent data={data} />
          ) : (
            <div>Aucune donnée à afficher</div>
          )}

          <div className='modal-footer py-4 space-x-4 no-print'>
            <button
              type='button'
              onClick={handlePrint}
              className='inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-300'
            >
              Imprimer
            </button>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="inline-flex items-center rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-300"
            >
              Retour
            </button>
          </div>
        </div>
      </div>
    </OrderLayout>
  );
}
